/* Slow Cow — cart drawer extras: discount code box + "add another case" buttons.
   Both re-render the drawer through Shopify's Section Rendering API, so totals,
   the shipping bar and the Kaching discounts refresh instantly. */
(function () {
  if (window.scCartReady) return;
  window.scCartReady = true;

  var pendingError = '';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function post(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }

  function pick(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function render(state) {
    var s = (state && state.sections) || {};
    if (s['cart-drawer']) {
      var src = pick(s['cart-drawer'], '.drawer__inner');
      var dst = document.querySelector('cart-drawer .drawer__inner');
      if (src && dst) dst.innerHTML = src.innerHTML;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof state.item_count === 'number') drawer.classList.toggle('is-empty', state.item_count === 0);
    }
    if (s['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var b = pick(s['cart-icon-bubble'], '.shopify-section');
      if (bubble && b) bubble.innerHTML = b.innerHTML;
    }
  }

  function routes() {
    return window.routes || { cart_update_url: '/cart/update', cart_add_url: '/cart/add' };
  }

  /* ---------- discount code box ---------- */
  class ScCartDiscount extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.btn = this.querySelector('.sc-disc__btn');
      this.err = this.querySelector('.sc-disc__err');
      if (pendingError) { this.showError(pendingError); pendingError = ''; }
      if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.apply(); });
      this.querySelectorAll('[data-sc-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.remove(btn.getAttribute('data-sc-remove')); });
      });
    }
    codes() {
      return (this.dataset.codes || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    }
    busy(on) {
      if (this.btn) { this.btn.disabled = on; this.btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
      this.classList.toggle('is-busy', on);
    }
    showError(msg) {
      if (!this.err) return;
      this.err.textContent = msg;
      this.err.hidden = !msg;
    }
    apply() {
      var self = this;
      var code = (this.input.value || '').trim();
      if (!code) { this.input.focus(); return; }
      var existing = this.codes();
      if (existing.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { this.input.value = ''; return; }
      var errorText = this.dataset.error || '';
      this.showError('');
      this.busy(true);
      post(routes().cart_update_url + '.js', { discount: existing.concat(code).join(',') })
        .then(function (state) {
          var list = state.discount_codes || [];
          var hit = list.filter(function (d) { return (d.code || '').toLowerCase() === code.toLowerCase(); })[0];
          if (!hit || hit.applicable === false) {
            // take the dead code back out so it doesn't sit in the cart, then show why
            return post(routes().cart_update_url + '.js', { discount: existing.join(',') }).then(function (clean) {
              pendingError = errorText;
              render(clean);
            });
          }
          render(state);
        })
        .catch(function () { self.showError(errorText); })
        .finally(function () { if (self.isConnected) self.busy(false); });
    }
    remove(code) {
      var self = this;
      var left = this.codes().filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); });
      this.busy(true);
      post(routes().cart_update_url + '.js', { discount: left.join(',') })
        .then(render)
        .catch(function () {})
        .finally(function () { if (self.isConnected) self.busy(false); });
    }
  }
  if (!customElements.get('sc-cart-discount')) customElements.define('sc-cart-discount', ScCartDiscount);

  /* ---------- "add another case" buttons ---------- */
  class ScCartUpsell extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.err = this.querySelector('.sc-up__err');
      this.querySelectorAll('[data-sc-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.add(btn); });
      });
    }
    add(btn) {
      var self = this;
      var id = parseInt(btn.getAttribute('data-sc-add'), 10);
      if (!id) return;
      this.querySelectorAll('[data-sc-add]').forEach(function (b) { b.disabled = true; });
      btn.setAttribute('aria-busy', 'true');
      // already in the cart? bump that same line (keeps one row per flavour); otherwise add it
      var key = btn.getAttribute('data-key');
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 0;
      var req = key
        ? post((routes().cart_change_url || '/cart/change') + '.js', { id: key, quantity: qty + 1 })
        : post(routes().cart_add_url + '.js', { items: [{ id: id, quantity: 1 }] });
      req
        .then(function (state) {
          render(state);
          document.dispatchEvent(new CustomEvent('sc:cart-updated'));
        })
        .catch(function (e) {
          if (self.err) { self.err.textContent = (e && (e.description || e.message)) || ''; self.err.hidden = !self.err.textContent; }
          self.querySelectorAll('[data-sc-add]').forEach(function (b) { b.disabled = false; });
          btn.removeAttribute('aria-busy');
        });
    }
  }
  if (!customElements.get('sc-cart-upsell')) customElements.define('sc-cart-upsell', ScCartUpsell);
})();
